// Last checkpoint split under the timer: the checkpoint and its time.

import { formatTime } from '../../game/settings';
import { el } from './dom';

const SHOW_MS = 3500;

export class Splits {
  readonly root = el('div', 'hud-split');
  private hideTimer = 0;

  show(label: string, time: number): void {
    this.root.replaceChildren(el('span', 'hud-split-label', label), el('span', 'hud-split-time', formatTime(time)));
    this.root.classList.add('visible');
    clearTimeout(this.hideTimer);
    this.hideTimer = window.setTimeout(() => this.root.classList.remove('visible'), SHOW_MS);
  }

  clear(): void {
    clearTimeout(this.hideTimer);
    this.root.classList.remove('visible');
  }
}
